<template>
    <div class="transparent-field transparent-multi-select-field">
        <common-filter
            :showLabelFirst="true"
            :label="'referrals'"
            :confirmButtonLabel="'change'"
            :options="preparedOptions"
            @filter-changed="filterChange"
        ></common-filter>
    </div>
</template>

<script>
    export default {
        props: {
            value: { type: Array, default: null },
            options: { type: Array, required: true },
            label: { type: String, default: null },
        },
        computed: {
            preparedOptions() {
                return this.options
                    .filter((v) => !!v || v === false)
                    .map((opt) => ({
                        label: opt.label,
                        value: this.value === null || this.value.includes(opt.value),
                        class: opt.class,
                    }))
            },
        },
        methods: {
            filterChange(filterData) {
                const onlySelected = filterData.filter((fd) => fd.value).map((fd) => fd.label)
                const selectedKeys = onlySelected.map((fd) => this.options.find((opt) => opt.label === fd).value)
                this.$emit('input', selectedKeys)
            },
        },
    }
</script>

<style scoped></style>
